<div class="row text-center">
  <div class="col-12" *ngFor="let item of menu.sections[0].items; let index = index">
    <img [src]="item.photo" alt="" class="img-fluid" [ngClass]="{'mb-6': index === menu.sections[0].items.length - 1}">
  </div>
</div>